import { styled } from 'styled-components'

import { mq } from 'styles/mq'
export const SocialContainer = styled.div`
  margin: 4rem auto 6rem;

  ${mq.medium} {
    margin: 6rem auto 10rem;
  }
  ${mq.large} {
    margin: 8rem auto 12rem;
  }
`
export const SocialInner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  ${mq.small} {
    gap: 12px;
  }
  ${mq.medium} {
    gap: 14px;
  }
`
export const SocialButton = styled.a`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--background);
  background: var(--grey);
  font-size: 2.4rem;
  text-decoration: none;
  ${mq.small} {
    width: 42px;
    height: 42px;
    font-size: 3.2rem;
  }
  ${mq.medium} {
    width: 48px;
    height: 48px;
    font-size: 3.6rem;
  }
  transition: opacity 0.5s;
  &:hover {
    opacity: 0.8 !important;
  }
`
export const Copyright = styled.p`
  text-align: center;
  font-size: 80%;
`
